// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {usePlantFromHierarchyId} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Suspense} from 'react'
import {Outlet, RouteObject} from 'react-router'

import {PLANT_STATUS_SUB_PATH} from '../consts'
import {performanceReportsFeatureTranslations} from '../localization'
import {PlantStatusPage} from '../pages'
import {getShiftSummaryPath, getStoppagesListPath} from '../utils'

const SuitePlantStatusPage = () => {
  const upmPlant = usePlantFromHierarchyId()

  if (!upmPlant) {
    return null
  }

  const stoppagesListPath = getStoppagesListPath(upmPlant.plantId, upmPlant.upmId)
  const shiftSummaryPath = getShiftSummaryPath(upmPlant.upmId)

  return (
    <PlantStatusPage
      plantId={upmPlant.plantId}
      // TODO: easyPomLinkPath={easyPomDashboardPath}
      stoppageListHref={stoppagesListPath}
      shiftSummaryHref={shiftSummaryPath}
    />
  )
}

const SuitePlantStatusRouteWrapper = () => {
  return (
    <ThemeProvider theme={useFundamentalMuiTheme()}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
          <SuitePlantStatusPage />
        </Suspense>
      </LocalizationProvider>
    </ThemeProvider>
  )
}

/**
 * A composable sub-route for the PlantStatus page.
 *
 * Designed to be nested inside any parent route whose page navigates to
 * `PLANT_STATUS_SUB_PATH` in it's feature.
 * By embedding this sub-route, the PlantStatus page becomes a child of the caller's
 * route tree, which preserves "back to" navigation and allows seamless integration
 * into other features without duplicating route definitions.
 *
 * Includes its own `FeatureTranslationsLoader` so it's self-contained — translations
 * are loaded regardless of whether the parent feature loads them.
 */
export const performanceReportsPlantStatusSubRoute: RouteObject = {
  path: PLANT_STATUS_SUB_PATH,
  element: (
    <FeatureTranslationsLoader translations={performanceReportsFeatureTranslations}>
      <Outlet />
    </FeatureTranslationsLoader>
  ),
  children: [
    {
      index: true,
      element: <SuitePlantStatusRouteWrapper />
    },
    stoppageAnalysisSubRoute
  ]
}

export const performanceReportsRoutes: RouteObject = {
  path: '*',
  element: (
    <FeatureTranslationsLoader translations={performanceReportsFeatureTranslations}>
      <Outlet />
    </FeatureTranslationsLoader>
  ),
  children: [
    {
      index: true,
      element: <SuitePlantStatusRouteWrapper />
    },
    stoppageAnalysisSubRoute
  ]
}
